import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CarouselItemDirective } from './directives/carousel-item.directive';
import { SpecialNumberInputDirective } from './directives/special-number-input.directive';
import { RdataPipe } from './pipes/rdata/rdata.pipe';

import { SpecialtyDropdownComponent } from './specialty-dropdown/specialty-dropdown.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import { PulsatingDotComponent } from './pulsating-dot/pulsating-dot.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { ToggleComponent } from './toggle/toggle.component';
import { AlertComponent } from './alert/alert.component';
import { ButtonComponent } from './button/button.component';
import { LoaderComponent } from './loader/loader.component';
import { VerifiedMessageComponent } from './verified-message/verified-message.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { RdataResultsComponent } from './rdata-results/rdata-results.component';
import { RdataUpgradeAdComponent } from './rdata-upgrade-ad/rdata-upgrade-ad.component';
import { SortComponent } from './sort/sort.component';
import { PaginationComponent } from './pagination/pagination.component';
import { RdataBadgeComponent } from './rdata-badge/rdata-badge.component';
import { AbbreviateNumberPipe } from './pipes/abbreviate-number/abbreviate-number.pipe';
import { StateAbbrToNamePipe } from './pipes/state/state-abbr-to-name.pipe';
import { ScorecardCarouselComponent } from './scorecard-carousel/scorecard-carousel.component';
import { ScorecardSectionComponent } from './scorecard-section/scorecard-section.component';
import { ScorecardFieldComponent } from './scorecard-field/scorecard-field.component';
import { ScorecardRatingComponent } from './scorecard-rating/scorecard-rating.component';
import { CarouselComponent } from './carousel/carousel.component';
import { IconComponent } from './icon/icon.component';
import { RadiosComponent } from './radios/radios.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { NumberInputMaskDirective } from './directives/number-input-mask.directive';

@NgModule({
  declarations: [
    AbbreviateNumberPipe,
    RdataPipe,
    StateAbbrToNamePipe,

    AlertComponent,
    AlertMessageComponent,
    AutocompleteComponent,
    ButtonComponent,
    BackButtonComponent,
    DropdownComponent,
    LoaderComponent,
    PaginationComponent,
    PulsatingDotComponent,
    RdataResultsComponent,
    RdataUpgradeAdComponent,
    RdataBadgeComponent,
    SortComponent,
    SpecialtyDropdownComponent,
    ToggleComponent,
    TooltipComponent,
    VerifiedMessageComponent,
    ScorecardCarouselComponent,
    ScorecardSectionComponent,
    ScorecardFieldComponent,
    ScorecardRatingComponent,
    SpecialNumberInputDirective,
    CarouselItemDirective,
    CarouselComponent,
    IconComponent,
    RadiosComponent,
    CheckboxComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CurrencyInputDirective,
    NumberInputMaskDirective
  ],
  exports: [
    AbbreviateNumberPipe,
    RdataPipe,
    StateAbbrToNamePipe,

    AlertComponent,
    AlertMessageComponent,
    AutocompleteComponent,
    ButtonComponent,
    BackButtonComponent,
    DropdownComponent,
    LoaderComponent,
    PaginationComponent,
    PulsatingDotComponent,
    RdataResultsComponent,
    RdataUpgradeAdComponent,
    RdataBadgeComponent,
    SortComponent,
    SpecialtyDropdownComponent,
    ToggleComponent,
    TooltipComponent,
    VerifiedMessageComponent,
    ScorecardCarouselComponent,
    ScorecardSectionComponent,
    ScorecardFieldComponent,
    ScorecardRatingComponent,
    SpecialNumberInputDirective,
    CurrencyInputDirective,
    NumberInputMaskDirective,
    CarouselComponent,
    IconComponent,
    CarouselItemDirective,
    RadiosComponent,
    CheckboxComponent,
  ],
  providers: [
    RdataPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ResolveLibModule { }
